export const CHAT_MESSAGES = {
  REVIEW_NEW_IMAGES: "Please review **all new images** and update your response. Set the chat_response field itself to empty string as this is an automated inference.",
} as const;